export default "__VITE_ASSET__TLd6fBGr__"